import { useMutation } from "@apollo/client";
import { MOMENT_REQUEST_CLIP } from "MVVM/GraphQL/mutations/momentRequestClip";

export const MomentViewModel = () => {
  const [momentRequestClip] = useMutation(MOMENT_REQUEST_CLIP, {
    onError: (err: any) => {
      console.log(`mutateReaction error! ${err.message}`);
    },
  });

  return {
    momentRequestClip,
  };
};
